import React from 'react';

/** Skeleton — shimmering placeholder block. */
export default function Skeleton({ height = 16, width = '100%', radius = 'var(--r-md)', className = '', style }) {
  return <div className={`skeleton${className ? ` ${className}` : ''}`} style={{ height, width, borderRadius: radius, ...style }} aria-hidden="true" />;
}
